import type {Dayjs} from 'dayjs';
import type {Point} from 'geojson';

export enum STATUS_FINSA {
  FOREST_MASS_CREATED = 'FOREST_MASS_CREATED',
  PENDING_PLOT_INVENTORY_APPRAISER = 'PENDING_PLOT_INVENTORY_APPRAISER',
  CUT_PENDING = 'CUT_PENDING',
  CUT_FORCED = 'CUT_FORCED',
  WEIGHT_PENDING = 'WEIGHT_PENDING',
  CUT_WEIGHTED = 'CUT_WEIGHTED',
}

export enum STATUS_ASEFOR {
  PENDING_INVENTORY_PLOTS = 'PENDING_INVENTORY_PLOTS',
  PENDING_SLAM = 'PENDING_SLAM',
  INVENTORY_PLOTS_COMPLETED = 'INVENTORY_PLOTS_COMPLETED',
}

export enum STATUS_FORTOP {
  PENDING_UAV_FLIGHT = 'PENDING_UAV_FLIGHT',
  UAV_FLIGHT_DONE = 'UAV_FLIGHT_DONE',
}

export enum STATUS_UAV {
  METRICS_PROCESSING = 'METRICS_PROCESSING',
  METRICS_SUCCESSFUL = 'METRICS_SUCCESSFUL',
  METRICS_FAILED = 'METRICS_FAILED',
}

export type STATUS = STATUS_FINSA | STATUS_ASEFOR | STATUS_FORTOP | STATUS_UAV;

export const ALL_STATUSES: STATUS[] = [
  ...Object.values(STATUS_FINSA),
  ...Object.values(STATUS_ASEFOR),
  ...Object.values(STATUS_FORTOP),
  ...Object.values(STATUS_UAV),
];

export type ForestMassStatus = {
  forestMassUuid: string;
  code: string;
  concello: string;
  appraiserName: string | null;
  plannedCuttingDate: Dayjs;
  position: Point;
  createdAt: Dayjs;
  finsaStatus: STATUS_FINSA;
  finsaStatusChangeDate: Dayjs;
  aseforStatus: STATUS_ASEFOR;
  aseforStatusChangeDate: Dayjs;
  fortopStatus: STATUS_FORTOP;
  fortopStatusChangeDate: Dayjs;
  uavMetricsStatus: STATUS_UAV | null;
  uavMetricsStatusChangeDate: Dayjs | null;
};
